// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","circularButton":"_3IIdDY","fadeInFrames":"_3yht_N"};